import { action, computed, observable } from 'mobx';
import * as React from 'react';
import FirstResultsModal from '../components/modals/FirstResultsModal';
import ShouldLoginModal from '../components/modals/ShouldLoginModal';
import UploadUnlockedModal from '../components/modals/UploadUnlockedModal';
import { trackEvent } from '../lib/tracking';
import { AbstractModel } from './AbstractModel';
import { ModalManager } from './ModalManager';
import { Routes } from '../constants';

export class OnboardingModel extends AbstractModel {
  @computed
  private get isLoggedIn() {
    return !this.rootStore.currentUser.isAnonymous;
  }
  @computed
  private get hasPhotosUploaded() {
    return this.rootStore.userPictures.pictures.length > 1;
  }
  /** Db value */
  @computed
  private get sawResultsReceivedPrompt() {
    return this.rootStore.currentUser.user?.onboarding_sawResultsReceivedPrompt;
  }
  @computed
  get sawInitialVotePairs() {
    return this.rootStore.currentUser.user?.onboarding_sawInitialVotePairs;
  }

  @computed
  get isAppStarting() {
    return this.rootStore.currentUser.isLoading || this.rootStore.userPictures.isLoading;
  }
  @observable
  private sawUploadModal = false;

  /** Local value */
  @observable
  private sawFirstVotesReceivedModal = false;

  @observable
  private sawLoginModal = false;

  // show "upload unlocked" modal when user has score screen unlocked but isn't there yet
  @action
  onUserVote = () => {
    if (
      !this.isAppStarting &&
      !this.hasPhotosUploaded &&
      !this.sawUploadModal &&
      this.rootStore.currentUser.isScoreScreenUnlocked &&
      window.location.pathname !== Routes.score
    ) {
      this.sawUploadModal = true;
      ModalManager.showModal(<UploadUnlockedModal />);
      trackEvent('upload_unlocked');
      return true;
    }
  };
  @action
  onVotesReceived = () => {
    if (
      !this.isAppStarting &&
      !this.sawFirstVotesReceivedModal &&
      !this.sawResultsReceivedPrompt &&
      this.rootStore.userPictures.pictures.length &&
      this.rootStore.currentUser.lockedVotesCount > 3
    ) {
      this.sawFirstVotesReceivedModal = true;
      this.rootStore.currentUser.setCurrentUserSawResult();
      ModalManager.showModal(<FirstResultsModal />);
      return true;
    }
  };
  @action
  onPhotosUpload = () => {
    if (!this.isLoggedIn && !this.sawLoginModal && this.hasPhotosUploaded) {
      this.sawLoginModal = true;
      ModalManager.showModal(<ShouldLoginModal />);
      return true;
    }
  };
  @action
  runHooks = () => {
    this.onUserVote() || this.onVotesReceived() || this.onPhotosUpload();
  };
}
